(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('MyDomainNotificationController', MyDomainNotificationController);

    MyDomainNotificationController.$inject = ['$rootScope', '$q', '$state', '$window', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'MyDomainNotification', '$scope', '$timeout', '$uibModal', 'TabObjects', 'AlertRules', 'TabFleets', 'WarningCategory', 'domain', 'AlertSystem'];

    function MyDomainNotificationController($rootScope, $q, $state, $window, ParseLinks, AlertService, pagingParams, paginationConstants, MyDomainNotification, $scope, $timeout, $uibModal, TabObjects, AlertRules, TabFleets, WarningCategory, domain, AlertSystem) {
        var vm = this;
        vm.myDomainNotification = [];
        vm.requestBody = {};
        vm.loadPage = loadPage;
        vm.tooggleStatus = tooggleStatus;
        vm.changePageSize = changePageSize;
        vm.applySearch = applySearch;
        vm.applyFilter = applyFilter;
        vm.transition = transition;
        vm.loadAll = loadAll;
        vm.enableTooltip = enableTooltip;

        vm.currentStateFilter = "my-domain-notification-filter";
        vm.currentState = "my-domain-notification";
        vm.predicates = pagingParams.predicates;
        vm.searchParams = pagingParams.search;
        vm.licence = $rootScope.licence;
        vm.filter = pagingParams.filter;
        vm.enableTelegram = [];
        vm.enableWebhook = [];
        vm.enableSlack = [];
        vm.enableMail = [];
        vm.mdnac = [];
        vm.showClose = false;
        vm.picker = {
            start: false,
            end: false
        };
        vm.notificationSystems = ['email', 'telegram'];
        vm.notification;
        vm.domain = domain;

        function enableTooltip(channel, id) {
            vm[channel][id].tooltip = true;
            $timeout(function () {
                vm[channel][id].tooltip = false;
            }, 2000);
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null") {
            vm.predicates = JSON.parse(retrievedOrder);
        }

        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll();

        function loadAll() {
            MyDomainNotification.get({
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
                search: vm.searchParams
            }, onSuccess, onError);

            function onSuccess(data, headers, notify) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.myDomainNotification = data.myDomainNotifications;
                vm.notification = data.notification;
                vm.page = pagingParams.page;
                $timeout(function () {
                    enableAlertSystem(vm.myDomainNotification); // to fix bug : notification channel symbol not loading
                }, 50);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: sort(),
                predicates: vm.predicates,
                search: vm.searchParams,
                itemsPerPageChosen: vm.itemsPerPageChosen,
            }, {notify: notify, location: "replace"});
        }

        function enableAlertSystem(myDomainNotifications) {
            myDomainNotifications.forEach(function (myDomainNotification) {
                vm.mdnac[myDomainNotification.id] = {};
                vm.mdnac[myDomainNotification.id].email = false;
                vm.mdnac[myDomainNotification.id].telegram = false;
                myDomainNotification.myDomainNotificationAlertConfigurations.forEach(function (mdnac) {
                    var name = mdnac.alertSystemType.name;
                    vm.mdnac[myDomainNotification.id][name] = mdnac.active;
                });
                if (!(domain.enableAlerting && domain.mailAlerting))
                    myDomainNotification.relatedAlertSystemType.Channelemail = vm.mdnac[myDomainNotification.id].email = domain.enableAlerting && domain.mailAlerting;
                if (!(domain.enableAlerting && domain.telegramAlerting))
                    myDomainNotification.relatedAlertSystemType.Channeltelegram = vm.mdnac[myDomainNotification.id].telegram = domain.enableAlerting && domain.telegramAlerting;
                vm.isEnableMail = myDomainNotification.relatedAlertSystemType.email != null && myDomainNotification.relatedAlertSystemType.email != undefined && myDomainNotification.relatedAlertSystemType.Channelemail != undefined && myDomainNotification.relatedAlertSystemType.Channelemail && vm.mdnac[myDomainNotification.id].email;
                vm.isEnableTelegram = myDomainNotification.relatedAlertSystemType.telegram != null && myDomainNotification.relatedAlertSystemType.telegram != undefined && myDomainNotification.relatedAlertSystemType.Channeltelegram != undefined && myDomainNotification.relatedAlertSystemType.Channeltelegram && vm.mdnac[myDomainNotification.id].telegram;
                vm.enableMail[myDomainNotification.id] = vm.setWarningStatus(vm.isEnableMail, domain.mailAlerting, vm.notification.warningEmail, myDomainNotification.relatedAlertSystemType.email, vm.mdnac[myDomainNotification.id].email, myDomainNotification.active);
                vm.enableTelegram[myDomainNotification.id] = vm.setWarningStatus(vm.isEnableTelegram, domain.telegramAlerting, vm.notification.warningTelegram, myDomainNotification.relatedAlertSystemType.telegram, vm.mdnac[myDomainNotification.id].telegram, myDomainNotification.active);
            });
        }

        vm.setWarningStatus = function (enabled, domainNotification, userNotification, related, wac, myDomainNotification) {
            var objToReturn = {status: false, config: {}};
            if (enabled) {
                if (related && domainNotification === true && userNotification === true && myDomainNotification === true) {
                    objToReturn.status = true;
                    objToReturn.config.color = 'color-green';
                } else {
                    objToReturn.status = true;
                    objToReturn.config.color = 'background-red';
                }
            } else objToReturn.config.color = 'color-grey';
            return objToReturn;
        }

        function tooggleStatus(myDomainNotification) {
            if (!!myDomainNotification.active) {
                $uibModal.open({
                    templateUrl: 'app/entities/my-domain-notification/modals/change-my-domain-notification-status.html',
                    controller: function ($uibModalInstance, entity) {
                        var vm = this;
                        vm.myDomainNotification = entity;
                        vm.clear = clear;
                        vm.stop = stop;

                        function stop() {
                            $uibModalInstance.close();
                        }

                        function clear() {
                            $uibModalInstance.dismiss('cancel');
                        }
                    },
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return myDomainNotification;
                        }
                    }
                }).result.then(function () {
                    myDomainNotification.active = !myDomainNotification.active;
                    MyDomainNotification.update(myDomainNotification, function () {
                        loadAll();
                    });
                });
            } else {
                $uibModal.open({
                    templateUrl: 'app/entities/my-domain-notification/modals/change-my-domain-notification-status.html',
                    controller: function ($uibModalInstance, entity) {
                        var vm = this;
                        vm.myDomainNotification = entity;
                        vm.clear = clear;
                        vm.stop = stop;

                        function stop() {
                            $uibModalInstance.close();
                        }

                        function clear() {
                            $uibModalInstance.dismiss('cancel');
                        }
                    },
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return myDomainNotification;
                        }
                    }
                }).result.then(function () {
                    myDomainNotification.active = !myDomainNotification.active;
                    MyDomainNotification.update(myDomainNotification, function () {
                        loadAll();
                    });
                });
            }
        }

        vm.changeStatus = function (myDomainNotification, type, notification, typeToCheck) {
            if (typeToCheck.status && notification === true) {
                $uibModal.open({
                    templateUrl: 'app/entities/my-domain-notification/modals/change-notification-channel.html',
                    controller: function ($uibModalInstance) {
                        var vm = this;
                        vm.clear = clear;
                        vm.stop = stop;
                        vm.myDomainNotification = myDomainNotification;
                        vm.type = type;
                        vm.notification = notification;

                        function stop() {
                            $uibModalInstance.close();
                        }

                        function clear() {
                            $uibModalInstance.dismiss('cancel');
                        }
                    },
                    backdrop: 'static',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('alertRules');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function () {
                    MyDomainNotification.myDomainNotifications({
                        id: myDomainNotification.id,
                        type: type
                    }, onChangeSuccess, onChangeError);
                });
            } else {
                vm.rerouteToSettings(vm.notification, vm.domain, type, typeToCheck);
            }
        };

        function onChangeSuccess(myDomainNotification) {
            vm.myDomainNotification.forEach(function (warn) {
                if (warn.id == myDomainNotification.id)
                    warn.relatedAlertSystemType = myDomainNotification.relatedAlertSystemType;
            });
            loadAll()
        }

        function onChangeError() {
        }

        vm.rerouteToSettings = function (userNotifications, domain, type, typeToCheck) {
            $uibModal.open({
                templateUrl: 'app/entities/my-domain-notification/modals/reroute-modal.html',
                controller: function ($uibModalInstance) {
                    var vm = this;
                    vm.clear = clear;
                    vm.stop = stop;
                    vm.notification = null;
                    vm.myDomainNotificationCondition = null;
                    vm.domain = domain;
                    vm.type = type;
                    vm.typeToCheck = typeToCheck;
                    if (type === 'email') {
                        vm.notification = userNotifications.warningEmail;
                        vm.myDomainNotificationCondition = vm.domain.mailAlerting;
                    } else if (type === 'telegram') {
                        vm.notification = userNotifications.warningEmail;
                        vm.myDomainNotificationCondition = vm.domain.telegramAlerting;
                    }

                    function stop() {
                        $uibModalInstance.close();
                    }

                    function clear() {
                        $uibModalInstance.dismiss('cancel');
                    }
                },
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'md',
                resolve: {}
            }).result.then(function () {
                $state.go('general-settings');
            });
        };

        function applyFilter() {
            if (vm.filter.start < vm.filter.end || vm.filter.start == vm.filter.end) {
                localStorage.setItem(vm.currentStateFilter, JSON.stringify(vm.filter));
                loadAll();
            } else {
                AlertService.error("Error validation date.");
            }
        }

        vm.notificationsHelp = function () {
            $uibModal.open({
                templateUrl: 'app/entities/warning/notifications-help.html',
                controller: 'NotificationsHelpController',
                controllerAs: 'vm',
                size: 'md',
            }).result.then(function () {
                $state.go('my-domain-notification');
            });
        };

        vm.deleteRule = function (id) {
            $uibModal.open({
                templateUrl: 'app/entities/my-domain-notification/my-domain-notification-delete-dialog.html',
                controller: 'MyDomainNotificationDeleteDialogController',
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', function ($translate) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'MyDomainNotification', function ($stateParams, MyDomainNotification) {
                        return MyDomainNotification.getOne({id: id});
                    }]
                }
            }).result.then(function () {
                loadAll();
            });
        };

        function applySearch() {
            pagingParams.page = 1;
            loadAll(false);
        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            //vm.savePage();
            vm.transition();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

    }
})
();
